/* Zero specificity, so the caller's class can set its own spacing. */
:where(.fieldset) {
	margin: 0;
	padding: 0;
	border: 0;
	min-width: 0;
}

.fieldset:disabled button {
	cursor: not-allowed;
}

/* WebKit fades disabled fields; what's typed in them is still content. */
.fieldset:disabled :is(input, textarea) {
	opacity: 1;
	-webkit-text-fill-color: currentColor;
}
